import { Component, OnInit, Output ,EventEmitter, Input} from '@angular/core';
import { faThumbsDown } from '@fortawesome/free-regular-svg-icons';
import { Utility } from 'src/app/common/utility';
import { StoreService } from 'src/app/services/store.service';

@Component({
  selector: 'week-calendar-picker',
  templateUrl: './week-calendar-picker.component.html',
  styleUrls: ['./week-calendar-picker.component.scss']
})
export class WeekCalendarPickerComponent implements OnInit {


  private date = new Date();

  private days = 7;

  private monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  private dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  public displayDays = [];

  private startDate = new Date(this.date);

  private selectedDate = new Date(this.date);

 @Input()  public TimeZoneOffset:number=0;
  constructor() { }
  //by default don't navigate backwards
 @Input() public hidePrevButton:boolean = true;
 @Output() public dateChanged:EventEmitter<Date> = new EventEmitter<Date>()
  nextSelected :number= 0;
  
  ngOnInit() 
  {
    if(this.TimeZoneOffset != 0)
    this.date = this.getDateInLocationTimeZone(this.TimeZoneOffset * 60)
    else
    this.date = new Date()
    this.selectedDate =  this.date;
    this.changeDate(this.date)
    this.dateChanged.emit(this.date);
    
  }

  getDateInLocationTimeZone(locationTimeZoneOffset:number)
  {
    let d = new Date();
    var utc_offset = d.getTimezoneOffset();
    //conver to UTC
    d.setMinutes(d.getMinutes() + utc_offset);
    //Convert UTC to Destination(location) timezone
    d.setMinutes(d.getMinutes() + locationTimeZoneOffset)
    return d;

  }
 
  changeDate(date) {
    const self = this;

    self.startDate = date;

    self.displayDays = [];

    const day = date.getDate();
    const t = new Date();

    const nc = self.days;

    for (let index = 0; index < self.days; index++) {
      const d = new Date(date);
      d.setDate(day + index);
      let selected = false;

      d.toDateString() === self.selectedDate.toDateString() ? selected = true : selected = false;

      self.displayDays.push({ fulldate: d, day: self.dayNames[d.getDay()], date: d.getDate(), month: self.monthNames[d.getMonth()], active: selected });
    }
  }

  loadWeek(e) {
    const self = this;

    const day = self.startDate.getDate();

		const newDay = new Date(self.startDate);

    if (e) {
      this.nextSelected++;
      newDay.setDate(day + self.days);
    } else {
      newDay.setDate(day - self.days);
      this.nextSelected--;
    }
    this.hidePrevButton = (this.nextSelected == 0)
    self.changeDate(newDay);
  }

  selectDate(e) {
    const self = this;
    self.displayDays.forEach(function (item) {
      e.toDateString() === item.fulldate.toDateString()? item.active = true : item.active = false;
    });
    //If it is today's date consider setting current time to weed out times passed by
    if(e.toDateString() == new Date().toDateString())
    {
      e.setTime(new Date().getTime())
      //calcuate time based on timezone off set only if date is today
      this.selectedDate = Utility.getDateWithtimeZoneOffset(e);
    }
    
    else{
      e.setHours(0);
      e.setMinutes(1);
    }
    this.selectedDate = e;
    
    
    this.dateChanged.emit(this.selectedDate);
  }
}
